module.exports = __webpack_public_path__ + "img/ywjs_02.43fea640.png";